module.exports = __webpack_public_path__ + "img/voice2.ade81e67.png";